import axios, { AxiosError, AxiosInstance, AxiosResponse, CreateAxiosDefaults } from "axios"

const httpConfig = (withAuth = true) => {
  const config: CreateAxiosDefaults = { baseURL: process.env.REACT_APP_BASE_URL }

  const axiosInstance: AxiosInstance = axios.create(config)

  axiosInstance.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      const authToken = localStorage.getItem('access_token')
      const profileId = localStorage.getItem('current_team')

      // Inject Auth Token
      if (withAuth) {
        config.headers.token = authToken
      }

      /// Inject Profile ID
      if (profileId && config.data) {
        // If FormData
        if (config.data instanceof FormData) {
          config.data.append("profile_id", profileId)
        }

        // If it's a plain object (i.e., JSON payload)
        else if (typeof config.data === "object") {
          config.data = {
            ...config.data,
            profile_id: Number(profileId),
          }
        }
      }


      return config
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error)
    }
  )

  axiosInstance.interceptors.response.use(
    function (response: AxiosResponse) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response
    },
    function (error: AxiosError) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error?.response)
    }
  )

  return axiosInstance
}

export default httpConfig